<template>
  <div class="admin-dashboard">
    <h2>Admin Panel</h2>
    <p>Welcome back 👋</p>

    <h4>Projects</h4>
    <div class="cards mb-8">
      <a
        v-for="card in projectsCards"
        :key="card.name"
        :href="card.url"
        target="_blank"
        class="card"
      >
        <img :src="card.img" :alt="card.name" class="bg-white" />
        <span>{{ card.name }}</span>
      </a>
    </div>


    <h4>Services</h4>
    <div class="cards">
      <a
        v-for="card in adminCards"
        :key="card.name"
        :href="card.url"
        target="_blank"
        class="card"
      >
        <img :src="card.img" :alt="card.name" />
        <span>{{ card.name }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import { adminCards } from "@/data/admin-cards";
import { projectsCards } from "@/data/projects-cards";

export default {
  name: "AdminDashboard",
  data() {
    return {
      adminCards,
      projectsCards
    };
  }
};
</script>

<style scoped>
.admin-dashboard {
  padding: 20px;
}

.cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 16px;
  margin-top: 20px;
}

.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 16px;
  border-radius: 16px;
  background: #111;
  color: white;
  text-decoration: none;

  transition: 0.2s ease;
}

.bg-white {
  background: white;
  color: #111;
}

.card:hover {
  transform: translateY(-4px);
  background: #1a1a1a;
}

.card img {
  width: 90px;
  height: 90px;
  object-fit: contain;
  margin-bottom: 10px;
}

.card span {
  font-size: 14px;
  text-align: center;
}

.mb-8 {
  margin-bottom: 32px;
}
</style>